import * as _ from "lodash";
/*
@deprecated
import from "@similarweb/pro-logic-components"
*/
export default (graphParams: FixmeType, configsList: FixmeType) =>
    configsList.reduce((prevConfig: FixmeType, configOrConfigFactory: FixmeType) => {
        const currentConfig = _.isFunction(configOrConfigFactory)
            ? configOrConfigFactory(graphParams)
            : configOrConfigFactory;
        // we pass customizer function to concat arrays (series, plotLines etc.)
        return _.mergeWith({}, prevConfig, currentConfig, (objVal, srcVal) => {
            if (_.isArray(objVal)) {
                return objVal.concat(srcVal);
            }
        });
    }, {});
